import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICpqResponseResponse } from '../../../models/cpq.models';
import { IconType } from '../../../models/settings.model';

@Component({
  selector: 'app-conflict-modal',
  templateUrl: './conflict-modal.component.html',
  styleUrls: ['./conflict-modal.component.scss'],
  standalone: false,
})
export class ConflictModalComponent {
  iconType: typeof IconType = IconType;
  @Input() open: boolean = false;
  @Input() conflict!: ICpqResponseResponse;
  @Output() accept: EventEmitter<any> = new EventEmitter<any>();
  @Output() undo: EventEmitter<any> = new EventEmitter<any>();
}
